export const LOGIN = 'login';

export const LOGOUT = 'logout';

export const TITLE = 'title'

export const CHECKWORK = 'checkwork'

export const LOCALIP = 'localip'

export const COURSERESOURCES = 'courseResources'

export const COURSEEXAM = 'courseExam'

export const COURSEEXAMTEMP = 'courseExamTemp'

export const TEACHERCOURSEDATA = 'teacherCourseData'

export const CACHETYPE = 'cacheType'   //上课页面缓存状态

export const CACHECLASS = 'cacheclass'   //储存班级

export const ANSWERSEND = 'answersend'   //发送抢答事件

export const ANSWERRECEIVE = 'answerreceive'   //发送抢答事件

export const STUDENTSAVEDATA = 'studentsavedata'   //学生端提交数据

export const STUDENTSAVESTATUS = 'studentsavestatus'   //学生端是否做题 1 是做过   0 没做

export const STUDENTJUDEEXAMTYPE = 'studentjudeexamtype'   //学生端是否是本节错题   1 是     0不是

export const CLASSTRIGGERID = 'classTriggerId'   //老师、学生触发id

export const EXAMHEADERCHOOSE = 'examheaderchoose'  //点击选择题时映射到头部显示

export const TRAGGEREXAMCARD = 'traggerexamcard'  //答题卡切换状态

export const SENDLAMPEVENT = 'sendlampevent'  //发送信号灯事件

export const RECELAMPEVENT = 'recelampevent'  //接收信号灯事件

export const SENDVOTEREVENT = 'sendvoterevent'  //发送投票事件

export const SENDVOTERDATAEVENT = 'sendvoterdataevent'  //发送投票事件数据

export const RECEVOTEREVENT = 'recevoterevent'  //接收投票事件

export const SENDWHITESCREEN = 'sendwhitescreen'  //发送白板事件

export const SENDSCOREEVENT = 'sendscoreevent'  //发送计分器事件

export const RECESCOREEVENT = 'recescoreevent'  //接收计分器事件

export const SENDSCOREDATAEVENT = 'sendscoredataevent'  //发送计分器事件数据

export const TIMERSEND = 'timersend'   //发送计时器

export const TIMERSENDEVENT = 'timersendevent'   //发送计时器

export const RECETIMERSENDEVENT = 'recetimersendevent'   //接受计时器事件

export const CUTDOWNSEND = 'cutdownsend'   //发送倒计时

export const DOWNTIMERSENDEVENT = 'downtimersendevent'   //发送倒计时

export const RECEDOWNTIMERSENDEVENT = 'recedowntimersendevent'   //接受计时器事件


export const LOCKSCREEN = 'lockscreen'   //发送锁屏

export const SENDSTOPVIDEOEVENT = 'sendstopvideoevent'; // 发送暂停视频播放事件

export const SENDPPTPREVIEWEVENT = 'sendpptpreviewevent'; // 发送PPT预览事件